module.exports = __webpack_public_path__ + "static/kns-06ddaf132aea67fc628bf66b430912c1.svg";